import {Schema, String, minLength} from 'effect/Schema';

export const BaseCurrencyCode = String.pipe(minLength(2)) as unknown as Schema<BaseCurrencyCode>;
export type BaseCurrencyCode = import('../../src/Currency/BaseCurrencyCode').BaseCurrencyCode;
